import { useEffect, useState, useRef } from "react";
import isEqual from "lodash/isEqual";

export function useDebounce<T>(value: T, delay = 600): T {
  const [debounced, setDebounced] = useState(value);
  const previousValue = useRef(value);

  useEffect(() => {
    if (isEqual(previousValue.current, value)) return;

    const t = setTimeout(() => {
      previousValue.current = value;
      setDebounced(value);
    }, delay);

    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
